import React from "react";

function Icon({ className }: { className: string }) {
  return (
    <svg viewBox="0 0 10 31.703" className={className}>
      <path
        d="M5,0l5,6H0L2.95,2.46Z"
        transform="translate(10 6) rotate(180)"
        fill="#fea439"
      />
      <line
        y2="25.703"
        transform="translate(5 6)"
        fill="none"
        stroke="#fea439"
        strokeWidth="1"
      />
    </svg>
  );
}

export { Icon };
